export default "__VITE_ASSET__35ac2aec__"